module.exports = __webpack_public_path__ + "img/car-item3.e7f65710.png";